import React from 'react';
import { Grid, Step, StepIconProps, StepLabel, Stepper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function StepIcon(props: Readonly<StepIconProps>) {
  const { active, completed, error } = props;

  if (error) {
    return <img src="/assets/icons/minus-circle.svg" alt="minus-circle" />;
  }
  if (completed) {
    return <img src="/assets/icons/check-circle-2.svg" alt="check-circle-2" />;
  }
  if (active) {
    return <img src="/assets/icons/check-circle.svg" alt="check-circle" />;
  }
  return <img src="/assets/icons/check-circle-3.svg" alt="check-circle-3" />;
}

export const steps = [
  {
    label: 1,
    description: `bookings.steps.linkCalendar`,
  },
  {
    label: 2,
    description: 'bookings.steps.setAvailability',
  },
  {
    label: 3,
    description: `bookings.steps.onlineConsultations`,
  },
  {
    label: 4,
    description: `bookings.steps.inPersonConsultations`,
  },
  {
    label: 5,
    description: 'bookings.steps.services',
  },
  {
    label: 6,
    description: `bookings.steps.setURL`,
  },
];

type IStepsProps = {
  activeStep: number;
  isProvideOnlineConsultations: boolean | null;
  setActiveStep: (_value: number) => void;
  maxActiveStep: number;
};

function Steps({
  activeStep,
  isProvideOnlineConsultations,
  setActiveStep,
  maxActiveStep,
}: Readonly<IStepsProps>) {
  const { t } = useTranslation();
  return (
    <Stepper activeStep={activeStep} orientation="vertical" connector={null}>
      {steps.map((step, index) => (
        <Step
          onClick={() => {
            if (index <= maxActiveStep) {
              setActiveStep(step.label - 1);
            }
          }}
          key={step.label}
          sx={{
            cursor: index <= maxActiveStep ? 'pointer' : 'default',
            padding: '16px 0 16px 16px',
            background: index === activeStep ? 'rgba(124, 174, 190, 0.20)' : '#fff',
            borderBottom: '0.5px solid rgba(124, 174, 190, 0.25)',
            borderRadius: index === 0 ? '10px 0 0 0' : 0,
            zIndex: 1,
          }}
        >
          <StepLabel
            StepIconProps={{
              error: index === 2 && isProvideOnlineConsultations === false,
              sx: { cursor: index <= maxActiveStep ? 'pointer' : 'default' },
            }}
            StepIconComponent={StepIcon}
          >
            <Grid
              display="flex"
              flexDirection="column"
              gap="2px"
              ml={0.5}
              sx={{ cursor: index <= maxActiveStep ? 'pointer' : 'default' }}
            >
              <Typography variant="caption2Bold" color="#7CAEBE">
                {t('activity.createActivity.step')} {step.label}
              </Typography>
              <Typography
                variant={index === activeStep ? 'subheadBold' : 'subheadRegular'}
                color="primary"
              >
                {t(step.description)}
              </Typography>
            </Grid>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

export default React.memo(Steps);
